import React from 'react'
import { PopoverFilter, PopoverViewType } from '~/components/shared'
import { EViewOptions, ViewsType } from '~/interfaces'

interface MedicalViewContentSelectorProps {
  view: ViewsType
  onChange: (newView: ViewsType) => void
}

export const MedicalViewContentSelector = ({ view, onChange }: MedicalViewContentSelectorProps): JSX.Element => {
  const icon = view === EViewOptions.HUMAN_BODY ? 'user' : 'singleTimeline'

  return (
    <PopoverFilter
      tooltipDescription={'Selecionar visualização'}
      iconName={icon}
      active={true}
      svgFilled
      selectedOption={view as string}
    >
      <PopoverViewType selectedOption={view} handleViewType={onChange} />
    </PopoverFilter>
  )
}
